import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { SegmentControlScrollable } from '@blade/ui-kit'

import { ordersPageSideFilterAtom, ordersPageTabAtom } from '../../atoms/mobile'

import type { OrdersPageSideFilter, OrdersPageTab } from '../../atoms/mobile'

type Props = {}

export const OrdersPageHeader: React.FC<Props> = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(ordersPageTabAtom)
  const [sideFilter, setSideFilter] = useAtom(ordersPageSideFilterAtom)

  return (
    <Root>
      <SegmentControlScrollable<OrdersPageTab>
        size="h24"
        value={tab}
        onChange={setTab}
        css={css`
          width: auto;
        `}
      >
        <SegmentControlScrollable.Item value="orders">
          {t('orders.page.title')}
        </SegmentControlScrollable.Item>
        <SegmentControlScrollable.Item value="tokens">
          {t('token_other')}
        </SegmentControlScrollable.Item>
      </SegmentControlScrollable>

      {tab === 'orders' ? (
        <SegmentControlScrollable<OrdersPageSideFilter>
          size="h24"
          value={sideFilter}
          onChange={setSideFilter}
          css={css`
            width: auto;
          `}
        >
          <SegmentControlScrollable.Item value="all">
            {t('common.all')}
          </SegmentControlScrollable.Item>
          <SegmentControlScrollable.Item value="buy">
            {t('trading.buy')}
          </SegmentControlScrollable.Item>
          <SegmentControlScrollable.Item value="sell">
            {t('trading.sell')}
          </SegmentControlScrollable.Item>
        </SegmentControlScrollable>
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-inline: 12px;
  margin-bottom: 12px;
`
